/** Shared react-data-table-component styling for the Help Center pages.
 *  Copied from the Calling V2 pages so the admin tables look identical. */
export const helpTableStyles = {
  table: { style: { backgroundColor: "#ffffff", borderRadius: "8px" } },
  headRow: { style: { backgroundColor: "#064c77", borderBottom: "1px solid #dee2e6", minHeight: "52px" } },
  headCells: { style: { color: "#ffffff", fontSize: "13px", fontWeight: "700", textTransform: "uppercase" } },
  rows: { style: { minHeight: "60px", backgroundColor: "#ffffff", "&:hover": { backgroundColor: "#f8f9fa" } } },
  cells: { style: { fontSize: "14px", color: "#495057", borderBottom: "1px solid #f1f3f5" } },
  pagination: { style: { borderTop: "1px solid #dee2e6", padding: "8px" } },
};
